import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface DialogConfirmacaoProps {
  aberto: boolean;
  mensagem: string;
  titulo?: string;
  textoConfirmar?: string;
  textoCancelar?: string;
  /**
   * [AJUSTE 21/08/2026] Falso para acao que NAO destroi nada. Muda a cor do botao e do
   * icone: vermelho com aviso e a linguagem de "voce vai perder algo", e usa-la para uma
   * emissao faz o usuario hesitar - ou pior, o treina a clicar no vermelho.
   */
  destrutivo?: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
}

/**
 * Confirmação para ações destrutivas.
 *
 * [AJUSTE 11/08/2026] Criado porque o "Excluir" do ButtonMenu fica logo abaixo do
 * "Editar" no mesmo dropdown, e o usuário acabava apagando cadastro por engano -
 * a exclusão acontecia no clique, sem nenhuma pergunta.
 *
 * Diálogo do MUI, e não o confirm() do navegador, por três motivos: o nativo
 * bloqueia a thread, não aceita estilo, e em vários navegadores oferece "não
 * mostrar mais esta mensagem" - o usuário marca uma vez e volta ao problema
 * original.
 *
 * O botão de confirmar NÃO é o padrão do teclado (autoFocus vai no Cancelar): quem
 * apertar Enter por reflexo cancela, que é o lado seguro de errar.
 */
export const DialogConfirmacao: React.FC<DialogConfirmacaoProps> = ({
  aberto,
  mensagem,
  titulo = 'Confirmar exclusão',
  textoConfirmar = 'Excluir',
  textoCancelar = 'Cancelar',
  destrutivo = true,
  onConfirmar,
  onCancelar,
}) => {
  return (
    <Dialog
      open={aberto}
      onClose={onCancelar}
      maxWidth='xs'
      fullWidth
      aria-labelledby='dialog-confirmacao-titulo'
    >
      <DialogTitle
        id='dialog-confirmacao-titulo'
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        {destrutivo
          ? <WarningAmberIcon color='warning' />
          : <HelpOutlineIcon color='primary' />}
        {titulo}
      </DialogTitle>

      <DialogContent>
        <DialogContentText>{mensagem}</DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancelar} autoFocus variant='outlined'>
          {textoCancelar}
        </Button>
        <Button onClick={onConfirmar} color={destrutivo ? 'error' : 'primary'} variant='contained'>
          {textoConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
